const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComingSoon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2122 2122",
    style: {
      enableBackground: "new 0 0 2122 2122"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 2121.32,
    height: 2121.32
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 713.6935,
    cy: 3133.6501,
    r: 602.3621,
    gradientTransform: "matrix(1.279 0 0 0.567 235.5643 -376.1399)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B6B6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1554,
    style: {
      stopColor: "#939393"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3326,
    style: {
      stopColor: "#BABABA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5085,
    style: {
      stopColor: "#D8D8D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6805,
    style: {
      stopColor: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8465,
    style: {
      stopColor: "#FBFBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    cx: 1148.378,
    cy: 1400.64,
    rx: 770.397,
    ry: 341.55
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -435.1238 1139.7178)",
    style: {
      fill: "#FFC500"
    },
    cx: 1158.199,
    cy: 1095.1,
    rx: 455.036,
    ry: 455.036
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#002E46",
      strokeWidth: 7.3657,
      strokeMiterlimit: 10
    },
    d: "M1547.762,728.452"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#002E46"
    },
    d: "M1256.409,1553.819c-112.525,0-220.992-41.015-305.417-115.499l4.87-5.524 c83.084,73.29,189.818,113.658,300.548,113.658c250.682,0,454.627-203.945,454.627-454.631 c0-250.678-203.945-454.623-454.627-454.623c-110.73,0-217.464,40.367-300.548,113.657l-4.87-5.524 c84.425-74.477,192.892-115.499,305.417-115.499c254.743,0,461.993,207.246,461.993,461.988 C1718.402,1346.566,1511.152,1553.819,1256.409,1553.819z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#002E46",
      strokeWidth: 7.3657,
      strokeMiterlimit: 10
    },
    d: "M1547.762,1415.917"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC500"
    },
    d: "M364.369,1087.421c-9.722-15.698-12.131-38.339-7.233-67.935l16.263-98.261 c5.01-30.264,14.893-53.135,29.661-68.611c14.764-15.465,36.979-23.209,66.643-23.209c28.283,0,47.176,6.837,56.667,20.5 c9.484,13.671,12.117,33.261,7.895,58.786l-3.816,23.039h-54.754l4.204-25.409c1.345-8.132,2.032-14.684,2.054-19.655 c0.022-4.963-1.349-9.088-4.107-12.365c-2.773-3.273-7.574-4.913-14.422-4.913c-10.265,0-17.425,3.277-21.471,9.822 c-4.053,6.561-7.125,16.156-9.218,28.801l-20.637,124.688c-2.132,12.876-2.01,22.479,0.367,28.801 c2.374,6.326,8.236,9.488,17.594,9.488c9.581,0,16.275-3.223,20.076-9.661c3.805-6.434,6.751-15.975,8.848-28.628l4.427-26.766 h54.76l-3.758,22.698c-4.338,26.208-13.512,46.478-27.521,60.821c-14.008,14.347-35.274,21.514-63.791,21.514 C393.67,1110.967,374.09,1103.12,364.369,1087.421z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC500"
    },
    d: "M553.845,1088.097c-10.024-15.246-12.584-37.659-7.686-67.255l16.933-102.325 c4.898-29.589,14.854-51.841,29.869-66.748c15.016-14.908,37.242-22.364,66.669-22.364c29.203,0,48.895,7.513,59.073,22.532 c10.175,15.026,12.833,37.217,7.973,66.579l-16.993,102.663c-4.859,29.366-14.882,51.671-30.07,66.917 c-15.184,15.249-37.379,22.87-66.583,22.87C583.599,1110.967,563.868,1103.346,553.845,1088.097z M640.583,1061.328 c4.366-6.434,7.492-15.299,9.362-26.596l21.478-129.767c1.87-11.293,1.662-20.043-0.611-26.262 c-2.284-6.208-8.211-9.315-17.799-9.315c-9.581,0-16.544,3.108-20.874,9.315c-4.338,6.218-7.442,14.969-9.312,26.262 l-21.478,129.767c-1.906,11.524-1.791,20.446,0.363,26.769c2.143,6.326,8.124,9.488,17.936,9.488 C629.232,1070.988,636.205,1067.766,640.583,1061.328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC500"
    },
    d: "M782.271,832.794h59.889l5.56,173.14l64.939-173.14h57.836L930.2,1107.241h-41.065L915.53,920.89 l-66.435,186.351h-34.908l-5.607-187.369l-35.117,187.369h-41.411L782.271,832.794z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC500"
    },
    d: "M1017.035,832.794h56.124l-45.428,274.447h-56.124L1017.035,832.794z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC500"
    },
    d: "M1115.245,832.794h39.357l37.99,142.642l23.612-142.642h46.884l-45.428,274.447h-37.986 l-36.476-151.792l-25.126,151.792h-48.254L1115.245,832.794z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC500"
    },
    d: "M1275.974,1086.741c-8.812-16.375-10.688-39.81-5.643-70.305l15.199-91.819 c5.161-31.171,15.174-54.832,30.057-70.985c14.875-16.148,37.145-24.227,66.809-24.227c28.513,0,47.675,6.895,57.494,20.67 c9.808,13.782,12.567,33.66,8.269,59.63l-2.636,15.929h-54.757l3.197-19.313c2.093-12.649,2.208-21.968,0.349-27.952 c-1.867-5.985-7.816-8.981-17.85-8.981c-10.264,0-17.446,3.388-21.532,10.164c-4.089,6.779-7.197,16.602-9.329,29.481 l-20.188,121.972c-2.132,12.876-1.945,22.759,0.569,29.646c2.507,6.895,8.783,10.337,18.824,10.337 c9.807,0,17.313-3.669,22.529-11.013c5.2-7.34,8.894-17.561,11.063-30.663l4.823-29.139h-27.035l5.607-33.883h78.027 l-23.331,140.951h-36.962l0.277-24.395c-11.584,18.972-28.326,28.46-50.229,28.46 C1302.65,1111.305,1284.782,1103.12,1275.974,1086.741z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC500"
    },
    d: "M806.099,1415.187c-10.484-13.893-13.879-35.408-10.196-64.546l49.945-8.132 c-2.424,17.396-2.093,30.214,0.993,38.454c3.083,8.25,9.074,12.371,17.972,12.371c6.618,0,11.753-2.089,15.411-6.272 c3.654-4.176,6.028-9.542,7.115-16.095c1.794-10.84,0.859-20.04-2.788-27.61c-3.657-7.568-9.983-15.868-18.978-24.906 l-24.654-24.733c-9.84-9.488-16.882-19.651-21.133-30.491c-4.255-10.844-5.125-23.831-2.619-38.968 c3.701-22.36,13.224-39.584,28.571-51.668c15.35-12.084,34.771-18.13,58.271-18.13c25.097,0,41.364,7.175,48.798,21.518 c7.438,14.346,10.009,32.584,7.711,54.721l-50.114,7.114c1.935-14.451,2.046-25.125,0.338-32.02 c-1.712-6.887-6.79-10.333-15.228-10.333c-6.161,0-11.336,2.316-15.526,6.945c-4.187,4.632-6.805,10.113-7.851,16.432 c-1.496,9.035-0.766,16.663,2.201,22.87c2.964,6.218,8.161,13.045,15.602,20.5l24.025,24.392 c11.322,11.524,19.694,23.669,25.115,36.429c5.416,12.76,6.704,27.73,3.863,44.892c-2.169,13.103-7.071,24.792-14.703,35.067 c-7.639,10.282-17.36,18.357-29.164,24.226c-11.811,5.869-24.787,8.808-38.928,8.808 C834.586,1436.022,816.575,1429.077,806.099,1415.187z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC500"
    },
    d: "M979.937,1413.155c-10.023-15.25-12.584-37.663-7.685-67.259l16.936-102.325 c4.898-29.589,14.854-51.841,29.866-66.744c15.015-14.911,37.242-22.367,66.672-22.367c29.204,0,48.891,7.517,59.07,22.532 c10.174,15.026,12.833,37.217,7.973,66.578l-16.993,102.667c-4.863,29.365-14.883,51.667-30.068,66.917 c-15.188,15.245-37.382,22.867-66.586,22.867C1009.691,1436.022,989.96,1428.401,979.937,1413.155z M1066.674,1386.386 c4.37-6.438,7.492-15.3,9.362-26.6l21.478-129.767c1.87-11.293,1.662-20.044-0.611-26.259c-2.283-6.211-8.211-9.318-17.796-9.318 c-9.581,0-16.544,3.108-20.878,9.318c-4.337,6.215-7.441,14.966-9.311,26.259l-21.479,129.767 c-1.906,11.523-1.791,20.446,0.368,26.768c2.14,6.326,8.121,9.488,17.932,9.488 C1055.324,1396.042,1062.298,1392.824,1066.674,1386.386z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC500"
    },
    d: "M1177.055,1413.155c-10.027-15.25-12.587-37.663-7.689-67.259l16.936-102.325 c4.895-29.589,14.85-51.841,29.869-66.744c15.012-14.911,37.239-22.367,66.669-22.367c29.203,0,48.891,7.517,59.069,22.532 c10.174,15.026,12.833,37.217,7.973,66.578l-16.993,102.667c-4.859,29.365-14.882,51.667-30.07,66.917 c-15.185,15.245-37.379,22.867-66.583,22.867C1206.806,1436.022,1187.075,1428.401,1177.055,1413.155z M1263.789,1386.386 c4.366-6.438,7.495-15.3,9.365-26.6l21.479-129.767c1.867-11.293,1.658-20.044-0.615-26.259 c-2.283-6.211-8.211-9.318-17.796-9.318c-9.581,0-16.544,3.108-20.877,9.318c-4.338,6.215-7.442,14.966-9.308,26.259 l-21.478,129.767c-1.91,11.523-1.791,20.446,0.359,26.768c2.143,6.326,8.124,9.488,17.936,9.488 C1252.439,1396.042,1259.412,1392.824,1263.789,1386.386z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC500"
    },
    d: "M1401.713,1157.848h39.357l37.99,142.646l23.611-142.646h46.884l-45.424,274.448h-37.986 l-36.479-151.792l-25.122,151.792h-48.258L1401.713,1157.848z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#002E46"
    },
    d: "M398.734,1053.056c-9.721-15.698-12.131-38.339-7.233-67.935l16.264-98.261 c5.009-30.265,14.893-53.135,29.66-68.611c14.764-15.465,36.98-23.208,66.644-23.208c28.283,0,47.175,6.837,56.666,20.5 c9.484,13.671,12.117,33.26,7.895,58.786l-3.816,23.039H510.06l4.204-25.409c1.346-8.132,2.032-14.685,2.054-19.655 c0.022-4.963-1.349-9.089-4.107-12.365c-2.772-3.273-7.574-4.913-14.422-4.913c-10.264,0-17.425,3.276-21.471,9.822 c-4.053,6.56-7.125,16.156-9.218,28.801l-20.637,124.688c-2.133,12.875-2.011,22.479,0.367,28.801 c2.373,6.326,8.236,9.487,17.594,9.487c9.581,0,16.274-3.223,20.076-9.66c3.805-6.434,6.751-15.975,8.848-28.628l4.427-26.766 h54.76l-3.758,22.698c-4.338,26.208-13.512,46.477-27.52,60.821c-14.009,14.346-35.275,21.515-63.792,21.515 C428.035,1076.603,408.455,1068.754,398.734,1053.056z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#002E46"
    },
    d: "M588.21,1053.732c-10.023-15.246-12.584-37.659-7.686-67.255l16.933-102.325 c4.898-29.588,14.854-51.84,29.869-66.748c15.016-14.907,37.242-22.363,66.669-22.363c29.204,0,48.895,7.513,59.073,22.532 c10.175,15.026,12.833,37.217,7.974,66.578l-16.994,102.663c-4.858,29.366-14.882,51.672-30.07,66.917 c-15.184,15.249-37.379,22.87-66.582,22.87C617.964,1076.603,598.233,1068.981,588.21,1053.732z M674.947,1026.963 c4.366-6.434,7.492-15.299,9.362-26.596L705.788,870.6c1.87-11.293,1.662-20.044-0.611-26.262 c-2.284-6.208-8.211-9.315-17.799-9.315c-9.581,0-16.544,3.108-20.874,9.315c-4.338,6.218-7.441,14.969-9.312,26.262 l-21.478,129.767c-1.906,11.523-1.791,20.446,0.363,26.769c2.144,6.326,8.125,9.487,17.936,9.487 C663.597,1036.623,670.57,1033.401,674.947,1026.963z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#002E46"
    },
    d: "M816.636,798.429h59.89l5.56,173.14l64.939-173.14h57.835l-40.296,274.447H923.5l26.395-186.351 l-66.435,186.351h-34.908l-5.607-187.369l-35.117,187.369h-41.411L816.636,798.429z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#002E46"
    },
    d: "M1051.4,798.429h56.124l-45.428,274.447h-56.124L1051.4,798.429z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#002E46"
    },
    d: "M1149.61,798.429h39.356l37.99,142.642l23.611-142.642h46.884l-45.427,274.447h-37.987 l-36.476-151.792l-25.125,151.792h-48.255L1149.61,798.429z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#002E46"
    },
    d: "M1310.34,1052.376c-8.812-16.375-10.689-39.81-5.644-70.305l15.199-91.819 c5.161-31.172,15.174-54.833,30.057-70.985c14.875-16.149,37.145-24.227,66.809-24.227c28.513,0,47.676,6.894,57.494,20.67 c9.807,13.781,12.566,33.66,8.268,59.63l-2.636,15.929h-54.757l3.198-19.314c2.093-12.649,2.208-21.967,0.349-27.952 c-1.867-5.985-7.816-8.981-17.85-8.981c-10.264,0-17.446,3.388-21.532,10.164c-4.089,6.779-7.197,16.602-9.329,29.48 l-20.187,121.973c-2.133,12.876-1.946,22.759,0.568,29.646c2.506,6.895,8.783,10.336,18.824,10.336 c9.807,0,17.314-3.668,22.529-11.013c5.2-7.341,8.894-17.562,11.063-30.664l4.823-29.139h-27.035l5.607-33.883h78.027 l-23.331,140.951h-36.962l0.277-24.395c-11.584,18.972-28.326,28.46-50.229,28.46 C1337.014,1076.941,1319.147,1068.754,1310.34,1052.376z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#002E46"
    },
    d: "M840.463,1380.822c-10.484-13.893-13.879-35.408-10.196-64.547l49.945-8.132 c-2.424,17.397-2.093,30.215,0.992,38.454c3.082,8.251,9.074,12.372,17.972,12.372c6.617,0,11.753-2.09,15.411-6.272 c3.654-4.176,6.028-9.542,7.115-16.095c1.794-10.84,0.86-20.04-2.787-27.61c-3.658-7.568-9.984-15.868-18.979-24.906 l-24.654-24.733c-9.84-9.488-16.882-19.652-21.133-30.491c-4.255-10.844-5.125-23.831-2.619-38.969 c3.701-22.359,13.224-39.583,28.571-51.667c15.35-12.084,34.771-18.13,58.271-18.13c25.096,0,41.364,7.175,48.798,21.517 c7.437,14.347,10.008,32.585,7.71,54.721l-50.114,7.115c1.935-14.451,2.046-25.126,0.338-32.02 c-1.712-6.888-6.79-10.333-15.228-10.333c-6.161,0-11.336,2.316-15.526,6.944c-4.186,4.632-6.804,10.114-7.851,16.433 c-1.496,9.035-0.766,16.663,2.201,22.87c2.964,6.218,8.16,13.045,15.602,20.5l24.025,24.391 c11.322,11.524,19.694,23.669,25.115,36.429c5.416,12.76,6.704,27.73,3.863,44.892c-2.169,13.102-7.071,24.792-14.703,35.067 c-7.639,10.282-17.36,18.357-29.164,24.226c-11.811,5.87-24.787,8.808-38.928,8.808 C868.951,1401.656,850.94,1394.712,840.463,1380.822z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#002E46"
    },
    d: "M1014.301,1378.79c-10.023-15.249-12.584-37.662-7.685-67.258l16.936-102.325 c4.898-29.589,14.854-51.84,29.866-66.744c15.016-14.911,37.242-22.367,66.673-22.367c29.203,0,48.891,7.517,59.069,22.532 c10.174,15.027,12.832,37.217,7.973,66.579l-16.993,102.667c-4.863,29.366-14.882,51.667-30.068,66.917 c-15.188,15.246-37.382,22.867-66.586,22.867C1044.056,1401.656,1024.325,1394.036,1014.301,1378.79z M1101.039,1352.021 c4.37-6.438,7.492-15.3,9.362-26.601l21.478-129.766c1.87-11.293,1.662-20.044-0.611-26.259 c-2.283-6.211-8.21-9.318-17.796-9.318c-9.581,0-16.544,3.108-20.878,9.318c-4.337,6.215-7.441,14.966-9.311,26.259 l-21.478,129.766c-1.906,11.524-1.791,20.447,0.367,26.769c2.14,6.327,8.121,9.488,17.932,9.488 C1089.688,1361.678,1096.662,1358.459,1101.039,1352.021z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#002E46"
    },
    d: "M1211.421,1378.79c-10.028-15.249-12.588-37.662-7.69-67.258l16.936-102.325 c4.895-29.589,14.85-51.84,29.869-66.744c15.012-14.911,37.239-22.367,66.669-22.367c29.204,0,48.891,7.517,59.069,22.532 c10.175,15.027,12.833,37.217,7.973,66.579l-16.993,102.667c-4.859,29.366-14.882,51.667-30.07,66.917 c-15.184,15.246-37.379,22.867-66.583,22.867C1241.171,1401.656,1221.44,1394.036,1211.421,1378.79z M1298.155,1352.021 c4.366-6.438,7.495-15.3,9.365-26.601l21.479-129.766c1.866-11.293,1.658-20.044-0.615-26.259 c-2.284-6.211-8.211-9.318-17.796-9.318c-9.581,0-16.544,3.108-20.877,9.318c-4.338,6.215-7.442,14.966-9.308,26.259 l-21.478,129.766c-1.91,11.524-1.791,20.447,0.359,26.769c2.143,6.327,8.124,9.488,17.936,9.488 C1286.803,1361.678,1293.777,1358.459,1298.155,1352.021z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#002E46"
    },
    d: "M1436.078,1123.483h39.356l37.99,142.646l23.611-142.646h46.884l-45.424,274.448h-37.986 l-36.479-151.792l-25.122,151.792h-48.258L1436.078,1123.483z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1484.072,
    y: 577.455,
    transform: "matrix(0.7072 -0.7071 0.7071 0.7072 48.1025 1278.4175)",
    style: {
      fill: "#002E46"
    },
    width: 166.667,
    height: 7.365
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 808.866,
    y: 1575.521,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -866.8111 1065.7402)",
    style: {
      fill: "#002E46"
    },
    width: 88.382,
    height: 7.365
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 985.52,
    y: 580.677,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -104.6475 916.075)",
    style: {
      fill: "#002E46"
    },
    width: 135.943,
    height: 7.365
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1623.386,
    y: 978.904,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -185.8229 1516.5498)",
    style: {
      fill: "#002E46"
    },
    width: 228.729,
    height: 7.365
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#002E46"
    },
    d: "M453.325,751.469c-2.921-3.869-3.862-9.854-2.841-17.968l13.908-2.273 c-0.67,4.848-0.579,8.416,0.281,10.718c0.86,2.287,2.524,3.438,5.003,3.438c1.844,0,3.276-0.576,4.29-1.741 c1.021-1.165,1.683-2.661,1.985-4.488c0.5-3.014,0.241-5.582-0.777-7.69c-1.017-2.107-2.78-4.416-5.286-6.934l-6.866-6.884 c-2.736-2.646-4.701-5.481-5.884-8.495c-1.183-3.021-1.427-6.639-0.73-10.854c1.032-6.229,3.683-11.02,7.956-14.386 c4.276-3.367,9.685-5.05,16.231-5.05c6.988,0,11.519,2,13.587,5.992c2.072,3.992,2.787,9.07,2.147,15.242l-13.954,1.971 c0.539-4.014,0.568-6.992,0.093-8.912c-0.479-1.92-1.892-2.877-4.244-2.877c-1.716,0-3.158,0.648-4.323,1.935 c-1.165,1.295-1.892,2.82-2.183,4.575c-0.417,2.518-0.216,4.647,0.615,6.373c0.824,1.727,2.269,3.633,4.341,5.711l6.69,6.79 c3.154,3.208,5.488,6.589,6.995,10.143c1.51,3.553,1.867,7.725,1.075,12.501c-0.605,3.654-1.967,6.905-4.097,9.768 c-2.122,2.863-4.83,5.107-8.117,6.747c-3.291,1.64-6.905,2.46-10.844,2.46C461.26,757.281,456.242,755.339,453.325,751.469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#002E46"
    },
    d: "M514.743,691.321h-11.912l1.906-11.516h39.457l-1.903,11.516h-11.725l-10.746,64.918h-15.822 L514.743,691.321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#002E46"
    },
    d: "M559.542,679.804h17.44l2.219,76.434h-14.487l-0.08-16.796h-12.199l-5.733,16.796h-14.775 L559.542,679.804z M564.703,729.818l0.421-30.765l-9.664,30.765H564.703z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#002E46"
    },
    d: "M598.698,725.948l-7.424-46.144h14.775l3.841,26.895l12.073-26.895h14.393l-22.503,46.144 l-5.014,30.29h-15.156L598.698,725.948z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#002E46"
    },
    d: "M672.193,691.321h-11.912l1.906-11.516h39.457l-1.903,11.516h-11.725l-10.747,64.918H661.45 L672.193,691.321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#002E46"
    },
    d: "M704.547,754.397c-2.924-1.92-4.752-4.704-5.482-8.351c-0.734-3.647-0.629-8.3,0.309-13.969 l8.649-52.272h15.44l-9.013,54.445c-0.601,3.653-0.63,6.516-0.086,8.588c0.55,2.071,2.219,3.107,5.013,3.107 c2.798,0,4.813-1.036,6.042-3.107c1.237-2.072,2.154-4.935,2.756-8.588l9.013-54.445h15.537l-8.653,52.272 c-0.935,5.669-2.374,10.322-4.313,13.969c-1.939,3.647-4.701,6.431-8.29,8.351c-3.593,1.92-8.247,2.884-13.965,2.884 C711.787,757.281,707.467,756.317,704.547,754.397z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#002E46"
    },
    d: "M763.685,679.804h10.962l10.581,39.728l6.575-39.728h13.055l-12.649,76.434h-10.577l-10.16-42.274 l-6.995,42.274h-13.44L763.685,679.804z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#002E46"
    },
    d: "M816.485,679.804h33.646l-1.78,10.754h-18.015l-3.356,20.292h13.912l-1.794,10.854h-13.915 l-3.967,23.967h18.206l-1.748,10.567h-33.837L816.485,679.804z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#002E46"
    },
    d: "M858.324,679.804h18.871c6.481,0,11.412,0.835,14.789,2.496c3.381,1.669,5.56,4.237,6.542,7.696 c0.986,3.46,1.003,8.057,0.054,13.775l-4.607,27.837c-0.967,5.848-2.507,10.552-4.621,14.105 c-2.115,3.553-5.121,6.201-9.031,7.927c-3.909,1.733-9.038,2.596-15.393,2.596h-19.252L858.324,679.804z M866.531,745.384 c2.733,0,4.822-0.424,6.265-1.273c1.442-0.849,2.475-2.093,3.094-3.726c0.622-1.633,1.187-3.992,1.697-7.078l5.233-31.614 c0.478-2.891,0.633-5.078,0.468-6.552c-0.169-1.482-0.831-2.582-1.986-3.302c-1.147-0.726-3.093-1.093-5.819-1.093h-3.337 l-9.046,54.639H866.531z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#002E46"
    },
    d: "M901.183,742.744h13.724l-2.233,13.494H898.95L901.183,742.744z M911.761,679.991h14.393 l-14.659,57.466h-5.054L911.761,679.991z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#002E46"
    },
    d: "M733.271,1267.813c5.12-66.924,0.52-125.214-10.49-154.249 c-105.08,64.678-218.68,92.734-243.799,98.403l-7.362,96.24c14.331,4.581,58.597,19.608,112.015,45.391l-0.408,5.333 c-0.622,8.14-7.728,14.563-15.84,14.317l-109.311-3.308c-8.11-0.245-14.203-7.068-13.58-15.207l4.211-55.045l7.984,0.242 l6.178-80.756l-49.03-1.484c-2.775-0.084-5.213,3.024-7.276,7.994l-15.752-0.477c-10.361-0.314-15.285,64.051-4.922,64.332 l15.751,0.477c1.292,5.104,3.244,8.345,6.02,8.429l24.68,0.748l-4.211,55.045c-1.315,17.196,11.555,31.608,28.689,32.126 l109.311,3.309c16.478,0.499,30.954-12.039,33.214-28.291c32.172,16.251,66.74,36.178,99.668,59.91 C714.521,1393.221,728.116,1335.191,733.271,1267.813z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#002E46"
    },
    d: "M750.836,1095.246c-4.879-0.148-9.819,3.298-14.636,9.763 c13.932,24.459,20.323,88.531,14.599,163.348c-5.742,75.065-21.976,138.588-39.641,161.925c0.178,0.144,0.382,0.286,0.567,0.43 c3.728,6.286,7.995,9.817,12.685,9.959c22.588,0.684,46.838-76.099,54.134-171.475 C785.841,1173.821,773.425,1095.929,750.836,1095.246z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#002E46"
    },
    d: "M779.549,635.014c-18.878,0-34.239-15.357-34.239-34.232c0-18.881,15.361-34.239,34.239-34.239 c18.878,0,34.235,15.358,34.235,34.239C813.784,619.656,798.427,635.014,779.549,635.014z M779.549,573.909 c-14.818,0-26.874,12.055-26.874,26.873c0,14.811,12.056,26.866,26.874,26.866c14.818,0,26.869-12.055,26.869-26.866 C806.418,585.964,794.367,573.909,779.549,573.909z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#002E46"
    },
    d: "M1093.818,1700.04c-21.285,0-38.601-17.314-38.601-38.598c0-21.284,17.317-38.605,38.601-38.605 c21.284,0,38.601,17.321,38.601,38.605C1132.419,1682.726,1115.101,1700.04,1093.818,1700.04z M1093.818,1630.202 c-17.224,0-31.236,14.013-31.236,31.24c0,17.22,14.012,31.233,31.236,31.233c17.224,0,31.236-14.013,31.236-31.233 C1125.053,1644.215,1111.042,1630.202,1093.818,1630.202z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComingSoon);
export default __webpack_public_path__ + "static/media/coming-soon.883f5c9d6cfdeea965686dcbd392c910.svg";
export { ForwardRef as ReactComponent };